import * as THREE from "three";
import {RaceRenderOrder} from "../../raceRenderOrder.js";

/**
 * Atmosphere for a planet
 */
export class PlanetAtmosphere {
    static SHADER_VERTEX = `
        varying vec3 iNormal;
        varying vec3 iPosition;
    
        void main() {
            iNormal = normal;
            iPosition = (modelMatrix * vec4(position, 1.0)).xyz;
            
            gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
        }
        `;
    static SHADER_FRAGMENT = `
        #define BOOST 2.
        
        uniform vec3 color;
        
        varying vec3 iNormal;
        varying vec3 iPosition;
        
        void main() {
            float fr = max(0.0, dot(normalize(iNormal), -normalize(cameraPosition - iPosition))) * BOOST;
            
            gl_FragColor = vec4(color, fr);
        }
        `;

    /**
     * Construct an atmosphere
     * @param {number} thickness The atmosphere thickness in the range [0, 1]
     * @param {number} color The atmosphere color
     */
    constructor(thickness, color) {
        this.thickness = thickness;
        this.color = color;
    }

    /**
     * Make the atmosphere mesh
     * @param {SphereGeometry} geometry The planet geometry
     * @returns {Mesh} The atmosphere mesh
     */
    makeMesh(geometry) {
        const material = new THREE.ShaderMaterial({
            uniforms: {
                color: new THREE.Uniform(new THREE.Color(this.color))
            },
            depthWrite: false,
            blending: THREE.AdditiveBlending,
            side: THREE.BackSide,
            vertexShader: PlanetAtmosphere.SHADER_VERTEX,
            fragmentShader: PlanetAtmosphere.SHADER_FRAGMENT
        });

        const mesh = new THREE.Mesh(geometry, material);

        mesh.scale.multiplyScalar(this.thickness + 1);
        mesh.renderOrder = RaceRenderOrder.ORDER_ATMOSPHERE;

        return mesh;
    }
}